import React from 'react';
import './SuccessStories.css';

function SuccessStories() {
  return (
    <section className="ss2__section">
      <div className="ss2__header">
        <p className="ss2__eyebrow">Skill-Up with ibots</p>
        <h2 className="ss2__title">Achievements of our Young Innovators</h2>
        <p className="ss2__sub">
          Our students go beyond the classroom — building real-world projects and competing at national level.
        </p>
      </div>

      <div className="ss2__feature-card">

        {/* Medal badge */}
        <div className="ss2__medal-row">
          <div className="ss2__medal">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#b45309" strokeWidth="1.8">
              <circle cx="12" cy="8" r="6"/>
              <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/>
            </svg>
          </div>
          <div>
            <span className="ss2__position">3rd Place</span>
            <span className="ss2__event">National-Level Tech Event · Bangalore</span>
          </div>
        </div>

        {/* Project name */}
        <h3 className="ss2__project-title">
          Zenith — <span>The Smart AgriBot</span>
        </h3>

        {/* Description */}
        <p className="ss2__project-desc">
          Our students secured Third place at a national-level tech event in Bangalore,
          competing with schools across India. Their project <strong>Zenith – The Smart AgriBot</strong> uses
          AI/ML to detect plant diseases, water dry plants, and navigate farms autonomously.
        </p>

        {/* Tech tags */}
        <div className="ss2__tags">
          {['AI / ML', 'Autonomous Navigation', 'Plant Disease Detection', 'Smart Agriculture', 'Robotics'].map((t, i) => (
            <span key={i} className="ss2__tag">{t}</span>
          ))}
        </div>

        {/* Competing note */}
        <div className="ss2__competing-note">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
          Competed against schools across India
        </div>

      </div>

      

    </section>
  );
}

export default SuccessStories;
